<sb-modal type="main" size="large">
    <ng-container *ngIf="{ instrument: instrument$ | async } as data">
        <sb-modal-header dialog="false">
            <div *ngIf="data.instrument; else loading">
                <h3 class="d-flex">
                    <sb-company-logo
                        *ngIf="data.instrument.website"
                        [companyWebsite]="data.instrument?.website"
                        [type]="
                            data.instrument?.instrumentData?.privateAssetType ??
                            data.instrument?.type
                        "
                        class="me-1"
                    ></sb-company-logo>
                    {{ data.instrument.decoratedInstrumentName || data.instrument.name }}
                </h3>
                <small>{{ data.instrument.type | strictTitleCase }}</small>
                <img
                    class="d-flex"
                    *ngIf="activeImage$ | async"
                    [src]="activeImage$ | async"
                    height="150px"
                    width="250px"
                />
            </div>
        </sb-modal-header>
        <sb-modal-body>
            <sb-pills [pills]="routes" type="tabs"></sb-pills>
            <router-outlet></router-outlet>
        </sb-modal-body>
        <sb-modal-footer dialog="false">
            <button
                *ngFor="let action of actions$ | async as actions"
                [disabled]="
                    !data.instrument ||
                    (data.instrument?.sold && action.id !== 'deleteAsset')
                "
                type="button"
                class="btn"
                [class.primary]="action?.type !== 'secondary'"
                [class.secondary]="action?.type === 'secondary'"
                (click)="callAction(action, $event)"
                [attr.data-cy]="'view-asset-' + action.name"
            >
                {{ action.name }}
                <sb-pending-button-indicator
                    *ngIf="action?.state$ | async as state"
                    [state]="state"
                ></sb-pending-button-indicator>
            </button>
            <!--  Temporary workaround for now  // TODO: refactor-->
            <button
                *ngIf="(data$ | async).showCommercialRealEstateLink"
                type="button"
                class="btn primary"
                [disabled]="!data?.instrument?.instrumentId"
                [routerLink]="[
                    '',
                    {
                        outlets: {
                            modal: [
                                'data-entry',
                                'commercial-real-estate',
                                data?.instrument?.instrumentId
                            ]
                        }
                    }
                ]"
            >
                Add or edit data
            </button>
        </sb-modal-footer>
    </ng-container>
</sb-modal>
<ng-template #loading>
    <div>
        <div
            class="skeleton-loader skeleton-loader-fill"
            style="height: 28px; width: 180px"
            aria-busy="true"
        >
            Loading asset name...
        </div>
        <div
            class="skeleton-loader skeleton-loader-fill mt-2"
            style="height: 14px; width: 60px"
            aria-busy="true"
        >
            Loading asset category...
        </div>
    </div>
</ng-template>
